<template>
  <div>
    <CoverageChecker/>
    <CoverageResult/>
  </div>
</template>

<script>
import { reactive, ref, provide } from 'vue'
import CoverageChecker from '@/components/CoverageChecker.vue'
import CoverageResult from "@/components/CoverageResult.vue";
import doesCoverageCheck from '@/actions/doesCoverageCheck.ts'
import redirectsOnInCoverage from "@/actions/redirectsOnInCoverage.ts";
import addsReferrerPromocode from '@/actions/addsReferrerPromocode.ts'
import addsSourcePage from "@/actions/addsSourcePage.ts";

export default {
  name: 'App',
  components: {
    CoverageResult,
    CoverageChecker
  },
  setup() {
    // Create per-instance state
    const geocodeResult = reactive({})
    const coverageCheckResult = reactive({})
    const loading = ref(false)
    const error = ref(false)

    // Provide state to child components
    provide('geocodeResult', geocodeResult)
    provide('coverageCheckResult', coverageCheckResult)
    provide('loading', loading)
    provide('error', error)

    // Initialize actions with per-instance state
    doesCoverageCheck(geocodeResult, loading, coverageCheckResult, error)
    redirectsOnInCoverage(coverageCheckResult)
  },
  mounted() {
    addsReferrerPromocode()
    addsSourcePage()
  }
}
</script>
